import React from 'react'
import DocumentModal from './DocumentModal'

const DocumentPreview = ({ document }) => {
    const {
        fields: {
            title,
            category: { fields: { name } } = { fields: {} },
            subCategory: { fields: { name: subname } } = { fields: {} },
            description,
            buttonText,
            file: {
                fields: {
                    file: { url },
                },
            },
        },
    } = document

    const downloadOnly = (url) => {
        if (url) {
            if (url.includes('.pptx') || url.includes('.docx')) {
                //url ends with pptx, docx
                return true
            }
        }

        return false
    }

    // for easier debugging
    const categoryName = name
    const subCategoryName = subname ? '| ' + subname : ''

    return (
        <div className="col-xs-12 col-md-6">
            {/* <a href={url} target="_blank" rel="noopener noreferrer" download className="border-box"> */}
            <span className="border-box">
                <p className="blog-date">
                    {categoryName} {subCategoryName}
                </p>
                <h2>{title}</h2>
                <p>{description}</p>
                {/* <span className="more-link">{buttonText ?? 'Download'}</span> */}

                {downloadOnly(url) ? (
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        className="more-link"
                    >
                        {buttonText ?? 'Download'}
                    </a>
                ) : (
                    <DocumentModal label={buttonText ?? 'Download'} videoUrl={url} />
                )}
            </span>
            {/* </a> */}
        </div>
    )
}

const DocumentDisplay = ({ documents }) => {
    return (
        <div id="blog-listing" className="col-section col-no-margin">
            {documents.length === 0 && (
                <p>There are no documents matching your search parameters</p>
            )}
            {documents.map((document) => {
                const {
                    sys: { id },
                } = document
                return <DocumentPreview key={id} document={document} />
            })}
        </div>
    )
}

export default DocumentDisplay
